import React from "react";
import { Link } from "react-router-dom";

const Promises = () => {
  return (
    <>
      <section className="promises py-5 my-5">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div>
                <div>
                  <p className="text-white text-uppercase let-space-2 font-w600">
                    Two Ways To Work With Us
                  </p>
                </div>
                <hr className="line-bot-blue-225" />
                <p className="text-white font-w800 font-50">
                  Pick the model that fits your team
                </p>
              </div>
            </div>
            <div className="col-md-7">
              <div className="row mb--90">
                <div className="mycard col-md-6 py-5">
                  <p className="font-25 text-light">
                    Staff Augmentation &amp; Dedicated Teams
                  </p>
                  <hr className="line-bot-blue-225" />
                  <p className="cardPara text-light">
                    Embedded Talent
                    <br /> On Your Roadmap
                  </p>
                  <p className="text-white font-16 text-left pl-3 mt-4">
                    Senior Product, UX, and Frontend talent embedded in your
                    team — scale up or down as your roadmap shifts.
                  </p>
                  <p className="readMore d-flex">
                    <Link
                      className="btn primary-btn text-dark bg-white"
                      to="/services/staffAugmentation"
                    >
                      Learn More
                    </Link>
                  </p>
                </div>
                <div className="mycardtwo col-md-6 py-4 bg-white my-4">
                  <p className="text-dark font-25">Project-Based Builds</p>
                  <hr className="line-bot-blue-225" />
                  <p className="text-dark">
                    Scoped Website,
                    <br /> Brand &amp; App Work
                  </p>
                  <p className="text-dark font-16 pl-3 mt-4">
                    Need a website, brand identity, or app built end to end
                    instead? We take on fixed-scope projects too.
                  </p>
                  <p className="readMore d-flex">
                    <Link className="btn primary-btn" to="/packages">
                      See Our Packages
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Promises;
